import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { STATUTS, PRIORITES } from "@/lib/crmHelpers";

export default function Filters({
  search,
  onSearchChange,
  statutFilter,
  onStatutChange,
  prioriteFilter,
  onPrioriteChange,
  dateFilter,
  onDateChange,
}) {
  const hasActive =
    search ||
    statutFilter !== "all" ||
    prioriteFilter !== "all" ||
    dateFilter !== "all";

  const reset = () => {
    onSearchChange("");
    onStatutChange("all");
    onPrioriteChange("all");
    onDateChange("all");
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="filters">
      <div className="relative min-w-[220px] flex-1">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Rechercher par nom ou téléphone..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          data-testid="filter-search"
          className="pl-9"
        />
      </div>
      <Select value={statutFilter} onValueChange={onStatutChange}>
        <SelectTrigger
          className="w-[150px]"
          data-testid="filter-statut"
        >
          <SelectValue placeholder="Statut" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tous statuts</SelectItem>
          {STATUTS.map((s) => (
            <SelectItem key={s.value} value={s.value}>
              {s.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={prioriteFilter} onValueChange={onPrioriteChange}>
        <SelectTrigger
          className="w-[140px]"
          data-testid="filter-priorite"
        >
          <SelectValue placeholder="Priorité" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Toutes priorités</SelectItem>
          {PRIORITES.map((p) => (
            <SelectItem key={p.value} value={p.value}>
              {p.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={dateFilter} onValueChange={onDateChange}>
        <SelectTrigger
          className="w-[160px]"
          data-testid="filter-date"
        >
          <SelectValue placeholder="Date" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Toutes dates</SelectItem>
          <SelectItem value="today">Aujourd'hui</SelectItem>
          <SelectItem value="week">Cette semaine</SelectItem>
        </SelectContent>
      </Select>
      {hasActive && (
        <Button
          variant="ghost"
          size="icon"
          onClick={reset}
          data-testid="filter-reset"
          title="Réinitialiser"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
